import React, { useEffect, useState } from "react"
import { Button } from "reactstrap"
import Icon from "components/common/Icon"

import { useGoogleMap } from "@react-google-maps/api"

import { MAX_ZOOM, MIN_ZOOM } from "constants/map"

const ZoomButtons = () => {
  const map = useGoogleMap()
  const [zoom, setZoom] = useState(map.zoom)

  // The map's zoom changes from outside this component too (fitBounds on search,
  // dragging, etc.), so mirror the live value instead of trusting stale local
  // state — otherwise +/- steps off a wrong baseline and jumps the view.
  useEffect(() => {
    const listener = map.addListener("zoom_changed", () => setZoom(map.getZoom()))
    return () => listener.remove()
  }, [map])

  const zoomHandler = (step) => () => {
    const current = map.getZoom()
    const newZoom = Math.max(MIN_ZOOM, Math.min(current + step, MAX_ZOOM))
    map.setZoom(newZoom)
    setZoom(newZoom)
  }
  return (
    <div className="pointer-events-auto flex-grow-0 vstack gap-2 ms-auto mt-auto">
      <Button color="white" onClick={zoomHandler(1)} className="btn-sm p-2 fs-7 shadow" disabled={zoom >= MAX_ZOOM}>
        <Icon iconName="Plus" size={16} />
      </Button>
      <Button color="white" onClick={zoomHandler(-1)} className="btn-sm p-2 fs-7 shadow" disabled={zoom <= MIN_ZOOM}>
        <Icon iconName="Minus" size={16} />
      </Button>
    </div>
  )
}

export default ZoomButtons
